import { useAccountStore, useProjectsStore } from '@/store';

const useProjectId = () => {
  const defaultProjectId = useAccountStore(
    (s) => s.account?.default_project?.id || ''
  );

  const selectedClientId = useProjectsStore((s) => s.selectedProject);
  const projectId = selectedClientId ? selectedClientId.id : defaultProjectId;

  return projectId;
};

export default useProjectId;
